import React from "react"

export const RecoveryPasswordPage= () => {
  return (
    <div>
      Recovery Password. 
    </div>
  )
}